import { render, staticRenderFns } from "./ViewInput.vue?vue&type=template&id=00c590b0&"
import script from "./ViewInput.vue?vue&type=script&lang=js&"
export * from "./ViewInput.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "ViewInput.vue"
export default component.exports